import "./index.css";
import mainofficeicon from "../../assets/shapes_svg/company/mainofficeicon.svg";
import add from "../../assets/shapes_svg/company/Plus.svg";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import { ShortButton, RegularButton } from "../../components/Button";
import Sections from "../../components/Sections";
import DeleteIcon from "@mui/icons-material/Delete";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import line from "../../assets/shapes_svg/sections/longline.svg";
import Dropdown from "../../components/Dropdown";
import {
  getBusinessSize,
  getBusinessDetail,
  createBusiness,
} from "../../apis/Business/Business";
import { getHeatingSource, getMaterial } from "../../apis/Dropdown";
import { useState, useEffect } from "react";
import EditableResult from "../../components/EditableResult";
import EditableResultList from "../../components/EditableResultList";
import EditableResultDropdown from "../../components/EditableResultDropdown";
import { useTranslation } from "react-i18next";
import { t } from "i18next";

export const DetailSection3 = ({ setSection }) => {
  const { t } = useTranslation();

  const [orisupplies, setOriSupplies] = useState([
    {
      name: "Office Pc",
      category: "PVC",
      quantity: "50",
      new_figure: "Wuhan, China",
      source: "Road",
    },
  ]);

  const [supplies, setSupplies] = useState([
    {
      name: "Office Pc",
      category: "PVC",
      quantity: "50",
      new_figure: "Wuhan, China",
      source: "Road",
    },
  ]);

  const [editSupplies, setEditSupplies] = useState([
    {
      name: false,
      category: false,
      quantity: false,
      new_figure: false,
      source: false,
      expand: false,
    },
  ]);

  const handleEditList = (value, index, property) => {
    setEditSupplies((editObjects) =>
      editObjects.map((editSupply, i) => {
        if (i == index) {
          let obj = { ...editSupply };
          obj[property] = value;
          return obj;
        }
        return editSupply;
      })
    );
  };

  const handleResultList = (value, index, property) => {
    setSupplies((prev) =>
      prev.map((vehicle, i) => {
        if (i == index) {
          let obj = { ...vehicle };
          obj[property] = value;
          return obj;
        }
        return vehicle;
      })
    );
  };

  const handleAddSupply = () => {
    setSupplies([
      ...supplies,
      {
        name: "",
        category: "",
        quantity: "",
        new_figure: "",
        source: "",
      },
    ]);
    setEditSupplies([
      ...editSupplies,
      {
        name: true,
        category: true,
        quantity: true,
        new_figure: true,
        source: true,
        expand: true,
      },
    ]);
    setOriSupplies([
      ...supplies,
      {
        name: "",
        category: "",
        quantity: "",
        new_figure: "",
        source: "",
      },
    ]);
  };

  return (
    <>
      <Sections selected={3} setSection={setSection} />
      <div className="modalcompanydetail__header">
        <div className="modalcompanydetail__header">
          <h3>{t("OPS_SUPPLIES")}</h3>
          <h4
            style={{
              fontWeight: "100",
              fontStyle: "italic",
              marginLeft: "10px",
            }}
          >
            (machines, paper, coffee, etc.)
          </h4>
        </div>
        <RegularButton click={handleAddSupply} text={t("ADD_MORE")} style={1} />
      </div>

      {supplies.map((supply, i) => {
        return (
          <div className="modalcompanydetail__group">
            <div className="modalcompanydetail__group__header">
              {editSupplies && editSupplies[i].expand == false ? (
                <ExpandMoreIcon
                  onClick={() => handleEditList(true, i, "expand")}
                />
              ) : (
                <ExpandLessIcon
                  onClick={() => handleEditList(false, i, "expand")}
                />
              )}
              <h4 style={{ marginLeft: "10px" }}>{supply.name},</h4>
              <h3>cat.</h3> <h4>{supply.category},</h4>
              <h3>qty.</h3> <h4>{supply.quantity}</h4> <h3>{t("TONNES")}.</h3>
            </div>
            {editSupplies && editSupplies[i].expand == true ? (
              <div className="modalcompanydetail__row">
                <div className="modalcompanydetail__group">
                  <div className="modalcompanydetail__question">
                    <h3>{t("NAME")}:</h3>
                    <EditableResultList
                      changed={orisupplies[i].name != supplies[i].name}
                      result={supply.name}
                      edit={editSupplies[i].name}
                      changeTo={supplies[i].name}
                      setValue={handleResultList}
                      indeks={i}
                      property={"name"}
                    />
                  </div>
                  <div className="modalcompanydetail__question">
                    <h3>{t("CATEGORY")}:</h3>
                    <EditableResultList
                      result={supply.category}
                      edit={editSupplies[i].category}
                      changeTo={supplies[i].category}
                      setValue={handleResultList}
                      indeks={i}
                      property={"category"}
                    />
                  </div>
                  <div className="modalcompanydetail__question">
                    <h3>{t("QUANTITY")}:</h3>
                    <EditableResultList
                      result={supply.quantity}
                      edit={editSupplies[i].quantity}
                      changeTo={supplies[i].quantity}
                      setValue={handleResultList}
                      indeks={i}
                      property={"quantity"}
                    />
                    <h4>{t("TONNES")}</h4>
                  </div>
                  <div className="modalcompanydetail__question">
                    <h3>{t("SHIPPED_FROM")}:</h3>
                    <EditableResultList
                      result={supply.new_figure}
                      edit={editSupplies[i].new_figure}
                      changeTo={supplies[i].new_figure}
                      setValue={handleResultList}
                      indeks={i}
                      property={"new_figure"}
                    />
                  </div>
                  <div className="modalcompanydetail__question">
                    <h3>{t("SHIPPED_BY")}:</h3>
                    <EditableResultList
                      result={supply.source}
                      edit={editSupplies[i].source}
                      changeTo={supplies[i].source}
                      setValue={handleResultList}
                      indeks={i}
                      property={"source"}
                    />
                  </div>
                </div>
                <div className="modalcompanydetail__question">
                  <h3>{t("EMBODIED_CARBON")}:</h3>
                  <h4>30 tonnes</h4>
                </div>
              </div>
            ) : null}
            <img
              style={
                editSupplies && editSupplies[i].expand == false
                  ? { marginTop: "10px" }
                  : { marginTop: "20px" }
              }
              src={line}
              alt=""
            />
          </div>
        );
      })}
      <div className="modalcompanydetail__option">
        <div className="modalcompanydetail__prev">
          <RegularButton click={() => setSection(2)} text={"Prev"} style={1} />
        </div>
      </div>
    </>
  );
};

export const DetailSection2 = ({ setSection }) => {
  const [numberEmployee, setNumberEmployee] = useState("");
  const [employeeTrain, setEmployeeTrain] = useState("");
  const [employeeCar, setEmployeeCar] = useState("");
  const [employeePlane, setEmployeePlane] = useState("");
  const [vehicles, setVehicles] = useState([
    {
      name: "Mitsubishi Outland",
      kmperyear: 30,
    },
  ]);

  const [editNumberEmployee, setEditNumberEmployee] = useState("");
  const [editEmployeeTrain, setEditEmployeeTrain] = useState(false);
  const [editEmployeeCar, setEditEmployeeCar] = useState(false);
  const [editEmployeePlane, setEditEmployeePlane] = useState(false);
  const [editVehicles, setEditVehicles] = useState([
    {
      name: false,
      kmperyear: false,
      expand: false,
    },
  ]);

  const { t } = useTranslation();

  const handleEditList = (value, index, property) => {
    setEditVehicles((editObjects) =>
      editObjects.map((editSupply, i) => {
        if (i == index) {
          let obj = { ...editSupply };
          obj[property] = value;
          return obj;
        }
        return editSupply;
      })
    );
  };

  const handleResultList = (value, index, property) => {
    setVehicles((prev) =>
      prev.map((vehicle, i) => {
        if (i == index) {
          let obj = { ...vehicle };
          obj[property] = value;
          return obj;
        }
        return vehicle;
      })
    );
  };

  const handleAddVehicles = () => {
    setVehicles([...vehicles, { name: "", kmperyear: "" }]);
    setEditVehicles([
      ...editVehicles,
      { name: true, kmperyear: true, expand: true },
    ]);
  };

  const handleDeleteVehicles = (index) => {
    setVehicles(vehicles.filter((vehicle, i) => i !== index));
    setEditVehicles(editVehicles.filter((vehicle, i) => i !== index));
  };

  return (
    <>
      <Sections selected={2} setSection={setSection} />
      <div className="modalcompanydetail__header">
        <h3>{t("VEHICLES")}:</h3>
        <RegularButton
          click={handleAddVehicles}
          text={t("ADD_VEHICLES")}
          style={1}
        />
      </div>
      {vehicles.map((vehicle, i) => {
        return (
          <div className="modalcompanydetail__group">
            <div className="modalcompanydetail__group__header">
              {editVehicles && editVehicles[i].expand == false ? (
                <ExpandMoreIcon
                  onClick={() => handleEditList(true, i, "expand")}
                />
              ) : (
                <ExpandLessIcon
                  onClick={() => handleEditList(false, i, "expand")}
                />
              )}
              <h4 style={{ marginLeft: "10px" }}>{vehicle.name},</h4>
              <h4>{vehicle.kmperyear}</h4> <h3> {t("km/year")}</h3>
            </div>

            {editVehicles && editVehicles[i].expand == true ? (
              <div className="modalcompanydetail__row">
                <div className="modalcompanydetail__group">
                  <div className="modalcompanydetail__question">
                    <h3>
                      {t("VEHICLE")} {i + 1}:
                    </h3>
                    <EditableResultList
                      result={vehicle.name}
                      edit={editVehicles[i].name}
                      changeTo={vehicles[i].name}
                      setValue={handleResultList}
                      indeks={i}
                      property={"name"}
                    />
                  </div>
                  <div className="modalcompanydetail__question">
                    <h3>{t("KMPERYEAR")}:</h3>
                    <EditableResultList
                      result={vehicle.kmperyear}
                      edit={editVehicles[i].kmperyear}
                      changeTo={vehicles[i].kmperyear}
                      setValue={handleResultList}
                      indeks={i}
                      property={"kmperyear"}
                    />
                  </div>
                </div>

                <div className="modalcompanydetail__question">
                  <h3>{t("EMISSION_RATE")}:</h3>
                  <h4>30 tonnes</h4>
                </div>

                <ShortButton
                  text={<DeleteIcon style={{ fontSize: "28px" }} />}
                  style={1}
                  click={() => handleDeleteVehicles(i)}
                />
              </div>
            ) : null}
            <img
              style={
                editVehicles && editVehicles[i].expand == false
                  ? { marginTop: "10px" }
                  : { marginTop: "20px" }
              }
              src={line}
              alt=""
            />
          </div>
        );
      })}

      <h3 style={{ marginTop: "30px", fontSize: "25px" }}>{t("EMPLOYEES")}</h3>
      <div className="modalcompanydetail__question">
        <h3>{t("NUMBER_EMPLOYEES")}:</h3>
        <EditableResult
          result={14}
          edit={editNumberEmployee}
          setEdit={setEditNumberEmployee}
          changeTo={numberEmployee}
          setValue={setNumberEmployee}
        />
      </div>
      <h4 style={{ fontWeight: 200, fontStyle: "italic" }}>
        {t("EMPLOYEE_TRAVEL")}:
      </h4>
      <div className="modalcompanydetail__row">
        <div className="modalcompanydetail__group">
          <div className="modalcompanydetail__question">
            <h3>{t("TRAIN_YEAR")}:</h3>
            <EditableResult
              result={28}
              edit={editEmployeeTrain}
              setEdit={setEditEmployeeTrain}
              changeTo={employeeTrain}
              setValue={setEmployeeTrain}
            />
          </div>
          <div className="modalcompanydetail__question">
            <h3>{t("CAR_YEAR")}:</h3>
            <EditableResult
              result={42}
              edit={editEmployeeCar}
              setEdit={setEditEmployeeCar}
              changeTo={employeeCar}
              setValue={setEmployeeCar}
            />
          </div>
          <div className="modalcompanydetail__question">
            <h3>{t("PLANE_YEAR")}:</h3>
            <EditableResult
              result={56}
              edit={editEmployeePlane}
              setEdit={setEditEmployeePlane}
              changeTo={employeePlane}
              setValue={setEmployeePlane}
            />
          </div>
        </div>

        <div className="modalcompanydetail__question">
          <h3>{t("EMISSION_RATE")}:</h3>
          <h4>70 tonnes</h4>
        </div>
      </div>
      <div className="modalcompanydetail__option">
        <div className="modalcompanydetail__prev">
          <RegularButton click={() => setSection(1)} text={"Prev"} style={1} />
        </div>
        <div className="modalcompanydetail__next">
          <RegularButton click={() => setSection(3)} text={"Next"} style={1} />
        </div>
      </div>
    </>
  );
};

export const ModalCompanyDetail = ({ businessId, closeModal }) => {
  document.getElementsByTagName("body")[0].className = "modal-open";

  const [addressLine1, setAddressLine1] = useState("");
  const [addressLine2, setAddressLine2] = useState("");
  const [city, setCity] = useState("");
  const [postcode, setPostcode] = useState("");
  const [businessSize, setBusinessSize] = useState("");

  const [editAddressLine1, setEditAddressLine1] = useState(false);
  const [editAddressLine2, setEditAddressLine2] = useState(false);
  const [editCity, setEditCity] = useState(false);
  const [editPostcode, setEditPostcode] = useState(false);
  const [editBusinessSize, setEditBusinessSize] = useState(false);

  const [heating, setHeating] = useState("El (kWh)");
  const [fuel, setFuel] = useState("");
  const [electricity, setElectricity] = useState("");
  const [water, setWater] = useState("");
  const [sewage, setSewage] = useState("");
  const [garbage, setGarbage] = useState("");
  const [recycling, setRecycling] = useState("");

  const [editHeating, setEditHeating] = useState(false);
  const [editFuel, setEditFuel] = useState(false);
  const [editElectricity, setEditElectricity] = useState(false);
  const [editWater, setEditWater] = useState(false);
  const [editSewage, setEditSewage] = useState(false);
  const [editGarbage, setEditGarbage] = useState(false);
  const [editRecycling, setEditRecycling] = useState(false);

  const [updating, setUpdating] = useState(false);

  const [adduser, setAddUser] = useState(false);

  const [section, setSection] = useState(1);

  const [dropdown, setDropdown] = useState([]);
  const [dropdownHeatingSource, setDropdownHeatingSource] = useState([]);
  const [dropdownMaterial, setDropdownMaterial] = useState([]);

  const { t } = useTranslation();

  const handleSaveBusinessInfo = () => {
    // updateBusinessDetail(businessId,addressLine1,addressLine2,city,postcode,businessSize,updating,setUpdating,setoriAddressLine1,setoriAddressLine2,setoriCity,setoriPostcode,setoriBusinessSize)
    // getBusinessDetail(businessId,setAddressLine1,setAddressLine2,setCity,setPostcode,setBusinessSize,setoriAddressLine1,setoriAddressLine2,setoriCity,setoriPostcode,setoriBusinessSize)
  };

  useEffect(() => {
    getBusinessDetail(
      businessId,
      setAddressLine1,
      setAddressLine2,
      setCity,
      setPostcode,
      setBusinessSize
    );
    getBusinessSize({ setBusinessSizeList: setDropdown });
    getHeatingSource({ setBusinessSizeList: setDropdownHeatingSource });
    getMaterial({ setBusinessSizeList: setDropdownMaterial });
  }, []);

  useEffect(() => {}, [dropdownHeatingSource]);
  return (
    <div className="modalcompanydetail">
      <div className="modalcompanydetail__modal">
        <div className="modalcompanydetail__close" onClick={closeModal}>
          <CloseIcon style={{ fontSize: "34px" }} />
        </div>

        {section && section == 1 ? (
          <>
            <Sections selected={section} setSection={setSection} />
            <h3 style={{ marginBottom: "2vh" }}>{t("LOCATION_INFO_1")}</h3>
            <div className="modalcompanydetail__section">
              <div className="modaladdlocation__question">
                <h3>{t("ADDRESS_LINE_1")}</h3>
                <h4>{}</h4>
                <EditableResult
                  changed={false}
                  result={addressLine1}
                  edit={editAddressLine1}
                  setEdit={setEditAddressLine1}
                  changeTo={addressLine1}
                  setValue={setAddressLine1}
                />
              </div>
              <div className="modaladdlocation__question">
                <h3>{t("ADDRESS_LINE_2")}</h3>
                <EditableResult
                  changed={false}
                  result={addressLine2}
                  edit={editAddressLine2}
                  setEdit={setEditAddressLine2}
                  changeTo={addressLine2}
                  setValue={setAddressLine2}
                />
              </div>
              <div className="modaladdlocation__question">
                <h3>{t("COUNTRY")}:</h3>
                <EditableResult
                  changed={false}
                  result={city}
                  edit={editCity}
                  setEdit={setEditCity}
                  changeTo={city}
                  setValue={setCity}
                />
              </div>
              <div className="modaladdlocation__question">
                <h3>{t("POSTCODE")}:</h3>
                <EditableResult
                  changed={false}
                  result={postcode}
                  edit={editPostcode}
                  setEdit={setEditPostcode}
                  changeTo={postcode}
                  setValue={setPostcode}
                />
              </div>
              <div
                style={{ marginBottom: "3vh" }}
                className="modaladdlocation__question"
              >
                <h3>{t("BUSINESS_SIZE")}:</h3>
                <EditableResultDropdown
                  changed={false}
                  result={businessSize}
                  edit={editBusinessSize}
                  setEdit={setEditBusinessSize}
                  changeTo={businessSize}
                  setValue={setBusinessSize}
                  setBusinessSize={setBusinessSize}
                  dropdown={dropdown}
                  setDropdown={setDropdown}
                  style={2}
                />
                {/* <EditableResult changed={businessSize  == oribusinessSize ? false: true} result={businessSize} edit={editBusinessSize} setEdit={setEditBusinessSize} changeTo={businessSize} setValue={setBusinessSize}/> */}
              </div>
              <RegularButton
                loading={updating}
                text={<SaveIcon style={{ fontSize: "28px" }} />}
                style={1}
                click={handleSaveBusinessInfo}
              />
              <img className="modalcompanydetail__line" src={line} alt="" />
            </div>

            <div className="modalcompanydetail__row">
              <div className="modalcompanydetail__question">
                <h3>{t("HEATING_SOURCE")}:</h3>
                <EditableResultDropdown
                  changed={false}
                  result={heating}
                  edit={editHeating}
                  setEdit={setEditHeating}
                  changeTo={heating}
                  setValue={setHeating}
                  setBusinessSize={setHeating}
                  dropdown={dropdownHeatingSource}
                  setDropdown={setDropdownHeatingSource}
                />
              </div>
              <div className="modalcompanydetail__question">
                <h3>{t("FUEL_YEAR")}:</h3>
                <EditableResult
                  result={"30"}
                  edit={editFuel}
                  setEdit={setEditFuel}
                  changeTo={fuel}
                  setValue={setFuel}
                />
              </div>
              <div className="modalcompanydetail__question">
                <h3>{t("EMISSION_RATE")}:</h3>
                <h4>{t("TONNES")}</h4>
              </div>
            </div>
            <div className="modalcompanydetail__row">
              <div className="modalcompanydetail__question">
                <h3>{t("ELEC_YEAR")}:</h3>
                <EditableResult
                  result={"60"}
                  edit={editElectricity}
                  setEdit={setEditElectricity}
                  changeTo={electricity}
                  setValue={setElectricity}
                />
              </div>
              <div className="modalcompanydetail__question">
                <h3>{t("EMISSION_RATE")}:</h3>
                <h4>{t("TONNES")}</h4>
              </div>
            </div>
            <div className="modalcompanydetail__question">
              <h3>{t("WATER_YEAR")}:</h3>
              <EditableResult
                result={"90"}
                edit={editWater}
                setEdit={setEditWater}
                changeTo={water}
                setValue={setWater}
              />
            </div>
            <div className="modalcompanydetail__question">
              <h3>{t("SEWAGE_YEAR")}:</h3>
              <EditableResult
                result={"120"}
                edit={editSewage}
                setEdit={setEditSewage}
                changeTo={sewage}
                setValue={setSewage}
              />
            </div>
            <div className="modalcompanydetail__row">
              <div className="modalcompanydetail__question">
                <h3>{t("GARBAGE_YEAR")}:</h3>
                <EditableResult
                  result={"150"}
                  edit={editGarbage}
                  setEdit={setEditGarbage}
                  changeTo={garbage}
                  setValue={setGarbage}
                />
              </div>
              <div className="modalcompanydetail__question">
                <h3>{t("RECYLE_YEAR")}:</h3>
                <EditableResult
                  result={"180"}
                  edit={editRecycling}
                  setEdit={setEditRecycling}
                  changeTo={recycling}
                  setValue={setRecycling}
                />
              </div>
              <RegularButton
                loading={updating}
                text={<SaveIcon style={{ fontSize: "28px" }} />}
                style={1}
                click={handleSaveBusinessInfo}
              />
            </div>
            <div className="modalcompanydetail__option">
              <div className="modalcompanydetail__next">
                <RegularButton
                  click={() => setSection(2)}
                  text={"Next"}
                  style={1}
                />
              </div>
            </div>
          </>
        ) : section && section == 2 ? (
          <DetailSection2 setSection={setSection} />
        ) : section && section == 3 ? (
          <DetailSection3 setSection={setSection} />
        ) : null}
      </div>
    </div>
  );
};

export const ModalAddLocation = ({ locations, setLocations, closeModal }) => {
  const [addressLine1, setAddressLine1] = useState("");
  const [addressLine2, setAddressLine2] = useState("");
  const [city, setCity] = useState("");
  const [postcode, setPostcode] = useState("");
  const [businessSize, setBusinessSize] = useState("");

  const [dropdown, setDropdown] = useState([]);
  const [saving, setSaving] = useState(false);

  const { t } = useTranslation();

  const handleAddLocation = () => {
    createBusiness(
      addressLine1,
      addressLine2,
      city,
      postcode,
      businessSize,
      saving,
      setSaving,
      closeModal,
      setLocations
    );
    // getBusinessList(setLocations)
  };

  useEffect(() => {
    getBusinessSize(dropdown, setDropdown);
  }, []);

  useEffect(() => {}, [businessSize]);
  document.getElementsByTagName("body")[0].className = "modal-open";
  return (
    <div className="modaladdlocation">
      <div className="modaladdlocation__modal">
        <div className="modaladdlocation__close" onClick={closeModal}>
          <CloseIcon style={{ fontSize: "34px" }} />
        </div>
        <h4>{t("BRANCHES")}:</h4>
        <div className="modaladdlocation__question">
          <h3>{t("ADDRESS_LINE_1")}:</h3>
          <input
            type="text"
            className="custom__input"
            value={addressLine1}
            onChange={(e) => setAddressLine1(e.target.value)}
          />
        </div>
        <div className="modaladdlocation__question">
          <h3>{t("ADDRESS_LINE_2")}:</h3>
          <input
            type="text"
            className="custom__input"
            value={addressLine2}
            onChange={(e) => setAddressLine2(e.target.value)}
          />
        </div>
        <div className="modaladdlocation__question">
          <h3>{t("POSTCODE")}:</h3>
          <input
            type="text"
            className="custom__input"
            value={postcode}
            onChange={(e) => setPostcode(e.target.value)}
          />
        </div>
        <div className="modaladdlocation__question">
          <h3>{t("COUNTRY")}:</h3>
          <input
            type="text"
            className="custom__input"
            value={city}
            onChange={(e) => setCity(e.target.value)}
          />
        </div>
        <div className="modaladdlocation__question">
          <h3>{t("BUSINESS_SIZE")}:</h3>
          {dropdown && dropdown.length > 0 ? (
            <Dropdown setBusinessSize={setBusinessSize} list={dropdown} />
          ) : null}
        </div>
        <RegularButton
          loading={saving}
          text={<SaveIcon style={{ fontSize: "28px" }} />}
          style={1}
          click={handleAddLocation}
        />
      </div>
    </div>
  );
};

export const AddLocation = ({ inputModal }) => {
  return (
    <div className="addlocation__container" onClick={inputModal}>
      <div className="addlocation">
        <h5>{t("ADD") + " " + t("FACILITY")}</h5>
        <img src={add} alt="" className="companycomponent__icon" />
      </div>
    </div>
  );
};

export const EPREconomic = ({ inputModal }) => {
  return (
    <div className="addlocation__container" onClick={inputModal}>
      <div className="addlocation">
        <h5>Connect to ERP System</h5>
        <img src={add} alt="" className="companycomponent__icon" />
      </div>
    </div>
  );
};

export const AddFranchise = ({ inputModal }) => {
  return (
    <div className="addlocation__container" onClick={inputModal}>
      <div className="addlocation">
        <h5>{t("ADD") + " " + "Franchise"}</h5>
        <img src={add} alt="" className="companycomponent__icon" />
      </div>
    </div>
  );
};

export const AddEquity = ({ inputModal }) => {
  return (
    <div
      className="addlocation__container"
      onClick={inputModal}
      style={{ marginTop: "15px" }}
    >
      <div className="addlocation">
        <h5
          style={{ fontWeight: "normal", maxWidth: "100px", fontSize: "14px" }}
        >
          {t("ADD_EQUITY")}
        </h5>
        <img src={add} alt="" className="companycomponent__icon" />
      </div>
    </div>
  );
};

export const AddDebt = ({ inputModal }) => {
  return (
    <div
      className="addlocation__container"
      onClick={inputModal}
      style={{ marginTop: "15px" }}
    >
      <div className="addlocation">
        <h5
          style={{ fontWeight: "normal", maxWidth: "100px", fontSize: "14px" }}
        >
          {t("ADD") + " " + t("Debt/Project")}
        </h5>
        <img src={add} alt="" className="companycomponent__icon" />
      </div>
    </div>
  );
};

const CompanyComponent = ({
  id,
  name,
  address_line_1,
  address_line_2,
  city,
  postcode,
  detailModal,
  location_number,
}) => {
  return (
    <div className="companycomponent__container">
      <div className="companycomponent">
        <h5>{name}</h5>
        <h6>{address_line_1}</h6>
        <img src={mainofficeicon} alt="" className="companycomponent__icon" />
      </div>
      <div className="companycomponent__option">
        {/* <img src={info} alt="" onClick={detailModal} />
            <img src={close} alt="" /> */}
      </div>
    </div>
  );
};

export default CompanyComponent;
